import {listQueue as list} from '@/domain/tarefas/services/queue'
import window from './window/window.js'

export default {
  pageTitle: 'Filas de Tarefas',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'name',
      sortable: true,
      parser: function (props) {
        return props.name
      }
    },
    {
      name: 'project',
      required: true,
      label: 'Projeto',
      align: 'left',
      field: 'project',
      sortable: true,
      parser: function (props) {
        return props.project ? props.project.name : ''
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: list,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    }
  }
}
